import React from 'react'
import { Link } from 'react-router'
import Twitter from './Twitter.png'
import Facebook from './Facebook.png'
import Google from './Google.png'
import Steam from './Steam.png'
import VK from './VK.png'
import Email from './Email.png'

export default class LoginBar extends React.Component {
  render () {
    const { baseUrl, selectLogin, className } = this.props

    return (
      <div className={className}>
        <a href={`${baseUrl}/auth/twitter`} style={styles.link}>
          <img src={Twitter} />
        </a>
        <a href={`${baseUrl}/auth/facebook`} style={styles.link}>
          <img src={Facebook} />
        </a>
        <a href={`${baseUrl}/auth/google`} style={styles.link}>
          <img src={Google} />
        </a>
        <a href={`${baseUrl}/auth/steam`} style={styles.link}>
          <img src={Steam} />
        </a>
        <a href={`${baseUrl}/auth/vk`} style={styles.link}>
          <img src={VK} />
        </a>
        <a onClick={(e) => e.preventDefault() || selectLogin('email')} style={styles.link}>
          <img src={Email} />
        </a>
        <p style={styles.guestLink}>or <Link to='/home' style={{ textDecoration: 'underline' }}>play as guest</Link></p>
      </div>
    )
  }
}

const styles = {
  link: {
    margin: '0.25em',
  },
  linkDisabled: {
    margin: '0.25em',
    opacity: 0.5,
  },
  linkHidden: { display: 'none' },
  guestLink: {
    marginTop: 5,
    color: '#322d63',
    fontFamily: 'fira_sanslight, Arial',
    fontSize: 20,
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Users/LoginBar.js
 **/